module.exports = __webpack_public_path__ + "static/img/son6.6a04a247.jpg";